import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { TextInput } from 'SRC/ui/FormElements'
import { priceMask } from 'Core/masks'

class PriceMonthly extends React.Component {
  componentDidUpdate () {
    const { priceMonthlyMasked } = this.props
    this.props.change(this.props.formName, 'priceMonthlyUnmasked', priceMonthlyMasked.toString().replace(',', '.'))
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.priceMonthlyMasked && this.props.priceMonthlyMasked !== nextProps.priceMonthlyMasked
  }
  render () {
    return [<TextInput
      id='priceMonthly'
      label='Mjesečno'
      name='priceMonthly'
      measure='€'
      mask={priceMask}
    />, <input id='priceMonthlyUnmaksed' type='hidden' name='priceMonthlyUnmaksed' />]
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(ownProps.formName)
  return {
    priceMonthlyMasked: selector(state, 'priceMonthly')
  }
}

PriceMonthly.propTypes = {
  priceMonthlyMasked: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired
}

PriceMonthly.defaultProps = {
  priceMonthlyMasked: ''
}

export default connect(mapStateToProps, {change})(PriceMonthly)
